export const handlingApiError = (error) => {
  const errorData = {
    success: false,
    status: 401,
    data: { detail: 'Error' }
  }

  if (error && error.response !== undefined) {
    const { data, status } = error.response
    errorData.status = status
    errorData.data = data
  }

  return errorData
}